export const createArrayByCheckboxValue = (e: any, id: number, itemsArr: number[]) => {
  const isChecked = e.target.checked;
  let newItemsArr = itemsArr?.length ? [...itemsArr] : [];
  isChecked ? newItemsArr.push(id) : (newItemsArr = newItemsArr.filter((item) => item !== id));

  return newItemsArr;
}
